import { ComponentProps, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './Input.module.css';
import useIsMobileView from '@/hooks/useIsMobileView';

export type InputProps = {
  error?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  maxLength?: number;
  icon?: React.ReactNode;
} & ComponentProps<'input'>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error = false, disabled = false, fullWidth = false, className, maxLength, ...props }, ref) => {
    const isMobileView = useIsMobileView();
    return (
      <input
        ref={ref}
        maxLength={maxLength}
        className={twMerge(
          styles.inputBase,
          !error ? styles.input : styles.inputError,
          disabled && styles.inputDisabled,
          fullWidth && 'w-full',
          isMobileView ? 'text-base' : 'text-sm',
          className,
        )}
        disabled={disabled}
        {...props}
      />
    );
  },
);

export default Input;
